// extracted by mini-css-extract-plugin
export default {"uploadIcon":"UploadFile_uploadIcon__XRW2Q","label":"UploadFile_label__AO5di","file":"UploadFile_file__Fl1pt","error":"UploadFile_error__IU0nk","divider":"UploadFile_divider__aSa9z"};